import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/money-graph-arrow-increase.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M152 120h-16V56h8a32 32 0 0 1 32 32 8 8 0 0 0 16 0 48.05 48.05 0 0 0-48-48h-8V24a8 8 0 0 0-16 0v16h-8a48 48 0 0 0 0 96h8v64h-16a32 32 0 0 1-32-32 8 8 0 0 0-16 0 48.05 48.05 0 0 0 48 48h16v16a8 8 0 0 0 16 0v-16h16a48 48 0 0 0 0-96m-40 0a32 32 0 0 1 0-64h8v64Zm40 80h-16v-64h16a32 32 0 0 1 0 64" }, null, -1)])]);
}
var money_graph_arrow_increase_default = { render };
//#endregion
export { money_graph_arrow_increase_default as default, render };

//# sourceMappingURL=money-graph-arrow-increase.svg.js.map